import type { Locale } from "@/i18n/routing";

export const localeLabels: Record<Locale, string> = {
  en: "English",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
  it: "Italiano",
};

export const localeFlags: Record<Locale, string> = {
  en: "🇺🇸",
  es: "🇪🇸",
  fr: "🇫🇷",
  de: "🇩🇪",
  it: "🇮🇹",
};

export const getLocaleLabel = (locale: Locale, includeName: boolean) =>
  includeName ? localeLabels[locale] : locale.toUpperCase();
